import { ROUTES } from 'config';
import { ActionsMenu } from 'melp-design/components';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useAdminDeleteAdmin } from 'store/admin-admins';
import { useConfirm } from 'store/confirm';
import { usePredefinedToasts } from 'utils/Toast';

interface Props {
  id: string;
  name: string;
}

export const AdminAdminsActions: FC<Props> = ({ id, name }) => {
  const { t } = useTranslation();
  const predefinedToasts = usePredefinedToasts();
  const history = useHistory();
  const { confirmation } = useConfirm();

  const { mutate: deleteAdmin, isLoading: isDeleting } = useAdminDeleteAdmin();

  return (
    <ActionsMenu
      items={[
        {
          label: t('actions.delete'),
          onClick: async () => {
            const { confirmed } = await confirmation(
              t('common.areYouSureToDelete', {
                title: name,
                interpolation: { escapeValue: false },
              }),
            );

            if (confirmed) {
              deleteAdmin(
                { adminId: id },
                {
                  onSuccess: () => {
                    predefinedToasts.success.deleted();
                    history.push(ROUTES.admin.admins.list);
                  },
                },
              );
            }
          },
          color: 'error',
          disabled: isDeleting,
        },
      ]}
    />
  );
};
